// @flow
import React from 'react';

const defaultRouter: RouterContext<> = (null: any);
export const routerContext = React.createContext<RouterContext<>>(defaultRouter);
